export default "__VITE_ASSET__BHCqaIBd__"